// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "companions-382QT";
var _5 = "description-3J0i0";
var _6 = "companions__added-2soeS";
var _7 = "loader-1hgJV";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "companions", _5 as "description", _6 as "companions__added", _7 as "loader" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "companions": _4, "description": _5, "companions__added": _6, "loader": _7 }
